/* Shared scroll-reveal layer. See sbs-motion.css for the markup contract. */
(() => {
 'use strict';
 if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

 /* Phones get a still first screen: nothing above the fold should fade or zoom before it can be read.
    Stripping the attributes is what does it, not a CSS override — every rule in sbs-motion.css is keyed on
    [data-motion] / [data-reveal], so removing them makes fade, mask, wipe, card and parallax inert at once,
    with no specificity fight and no per-variant reset list. On the home hero the root IS the hero, so
    dropping data-motion also starves the bespoke keyframes in home.css of their .is-animated class.
    Checked once at load, like the reduced-motion check above it. */
 if (innerWidth <= 767) {
  const heroes = '.sbs-home-hero,.sbs-home-benefits,.sbs-quiz__intro,.sbs-looks__intro,.sbs-share__intro,' +
   '.sbs-ed-intro,.sbs-ed-hero,.sbs-ed-ethos__hero,.sbs-ed-why__hero,.sbs-ed-best__hero,' +
   '.shades-hero,.sbs-shop-intro';
  document.querySelectorAll(heroes).forEach(hero => {
   hero.removeAttribute('data-motion');
   hero.querySelectorAll('[data-reveal]').forEach(el => el.removeAttribute('data-reveal'));
  });
 }

 document.querySelectorAll('[data-motion]').forEach(root => {
  root.classList.add('is-animated');
  /* Items that arrive together are staggered, so a run of short lines lands one by one. */
  const reveal = new IntersectionObserver(entries => {
   entries.filter(entry => entry.isIntersecting).forEach((entry, i) => {
    entry.target.style.transitionDelay = Math.min(i, 6) * 90 + 'ms';
    entry.target.classList.add('is-in');
    reveal.unobserve(entry.target);
   });
  }, {rootMargin: '0px 0px -12% 0px', threshold: 0.1});
  root.querySelectorAll('[data-reveal]').forEach(el => reveal.observe(el));
 });
})();
